"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IExternalComponentConditionSchema = void 0;
const zod_1 = require("zod");
const IExternalComponent_1 = require("./IExternalComponent");
exports.IExternalComponentConditionSchema = zod_1.z.object({
    name: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    functionSignal: zod_1.z.string(),
    components: zod_1.z.lazy(() => IExternalComponent_1.IExternalComponentSchema).array(),
});
//# sourceMappingURL=IExternalComponentCondition.js.map